import {
  type AppLanguage,
  DEFAULT_APP_LANGUAGAE,
} from "./types/app-languages.types";

export const toAppLanguage = (lng: string | undefined | null): AppLanguage => {
  if (lng) {
    if (lng.startsWith("fr")) return "fr";
    if (lng.startsWith("en")) return "en";
  }

  return DEFAULT_APP_LANGUAGAE;
};
